import { Injectable } from '@angular/core';
import { Message } from 'src/app/models/message';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  constructor() { }

  handleError(error: any): Message {
    let msg: Message = { code: 0 };
    let errorMessage = 'Ocurrió un error inesperado. Por favor intente más tarde';
    if (error.status) {
      msg.status = error.status;
      switch (error.status) {
        case 400:
          // Bad Request
          errorMessage = 'La solicitud fue incorrecta. Por favor, comprueba los datos enviados.';
          break;
        case 401:
          // Unauthorized
          errorMessage = 'No estás autorizado para realizar esta acción. Por favor, inicia sesión.';
          break;
        case 403:
          // Forbidden
          errorMessage = 'No tienes permiso para realizar esta acción.';
          break;
        case 404:
          // Not Found
          errorMessage = 'El recurso solicitado no se encuentra.';
          break;
        case 408:
          // Request Timeout
          errorMessage = 'La solicitud tardó demasiado tiempo. Por favor, inténtalo de nuevo.';
          break;
        case 429:
          // Too Many Requests
          errorMessage = 'Has realizado demasiadas solicitudes en poco tiempo. Por favor, intenta de nuevo más tarde.';
          break;
        case 500:
          // Internal Server Error
          errorMessage = 'Hay un problema con el servidor, por favor intente más tarde.';
          break;
        case 503:
          // Service Unavailable
          errorMessage = 'El servicio está temporalmente inaccesible. Por favor, intenta de nuevo más tarde.';
          break;
      }
    }
    msg.message = errorMessage;
    return msg;
  }
}
